export enum ProductType {
  MULTIPLE_VARIANT = "multiple_variants",
  BUNDLE = "bundle",
}
